import { forwardRef, type InputHTMLAttributes } from 'react'

import { CheckIcon } from '@/components/ui/icons'
import { cn } from '@/lib/utils/cn'

import styles from './Checkbox.module.css'

export interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  invalid?: boolean
}

/** A styled checkbox — register it directly, like any other native input. */
export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(function Checkbox(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <span className={cn(styles.box, invalid && styles.invalid, className)}>
      <input ref={ref} type="checkbox" className={styles.input} {...rest} />
      <CheckIcon className={styles.check} />
    </span>
  )
})
